module.exports = __webpack_public_path__ + "static/media/icon-myaccount-grey.b7231ff4.png";